import React, { useCallback } from "react";
// @ts-ignore
import ReactDragListView from "react-drag-listview";
import { observer } from "mobx-react";
import VirtualTable, { VirtualTableProps } from "./VirtualTable";
import SettingsStore from "../../../stores/SettingsStore";
import { NOT_DRAGGABLE_CLASS_NAME } from "../../../constants/table";

interface ReordableVirtualTableProps<T> extends VirtualTableProps<T> {
  settingsStore: SettingsStore;
}

const ReordableVirtualTable = <T extends Object>({
  settingsStore,
  selected,
  ...props
}: ReordableVirtualTableProps<T>): React.ReactElement => {
  const onDragEnd = useCallback(
    (fromIndex: number, toIndex: number) => {
      settingsStore.onColumnDragEndHandler(fromIndex, toIndex);
    },
    [settingsStore]
  );

  if (settingsStore.isEnabledReorder) {
    return (
      <ReactDragListView
        nodeSelector="th.reordable"
        onDragEnd={onDragEnd}
        ignoreSelector={`th.${NOT_DRAGGABLE_CLASS_NAME}`}
        enableScroll={false}
      >
        <VirtualTable {...props} />
      </ReactDragListView>
    );
  }

  return <VirtualTable {...props} selected={selected} />;
};

export default observer(ReordableVirtualTable);
